module.exports = __webpack_public_path__ + "static/img/2.bec1dc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/pengu/2.png
// module id = nwKF
// module chunks = 35